import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import { statusValidationForm } from "../../utils/validationSchema";
import StatusForm from "./StatusForm";
import Form from "../../layouts/Form";

const EditStatus = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    watch,
    clearErrors
  } = useForm<any>({
    resolver: yupResolver(statusValidationForm),
    defaultValues: async () => {
      let data: any = await props?.handleLazyFetch()
      return {
        ...data.data
      }
    }
  });
  const { handleEdit, statusList, isLoading } = props;
  return (
    <Form
      handleSubmit={handleSubmit}
      handleFormSubmit={handleEdit}
      setError={setError}
      buttonLabel={"Update"}
      isLoading={isLoading}
    >
      <StatusForm
        errors={errors}
        clearErrors={clearErrors}
        register={register}
        statusList={statusList}
        setValue={setValue}
        getValues={getValues}
        watch={watch}
      />
    </Form>
  );
};

export default EditStatus;
